export const STORE_PAGE_STATE = 'STORE_PAGE_STATE';
export const RESET_PAGE_STATE = 'RESET_PAGE_STATE';

const INITIAL_STATE = {
    pageState: {}
};

export default function dswTrainingPlans(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

export const getPageState = (state, pageKey) => {
    return state.dswTrainingPlans.pageState[pageKey];
};

// Actions
export const storePageState = (pageKey, pageState) => {
    return {
        type: STORE_PAGE_STATE,
        payload: {
            pageKey,
            pageState
        }
    };
};

export const resetPageState = (pageKey) => {
    return {
        type: RESET_PAGE_STATE,
        payload: {
            pageKey
        }
    };
};

const setPageState = (state, action) => {
    const key = action.payload.pageKey;
    return {
        ...state,
        pageState: {
            ...state.pageState,
            [key]: action.payload.pageState
        }
    };
};

const clearPageState = (state, action) => {
    const key = action.payload.pageKey;
    delete state.pageState[key];
    return {
        ...state,
        pageState: {
            ...state.pageState
        }
    };
};

const handlers = {
    [STORE_PAGE_STATE]: setPageState,
    [RESET_PAGE_STATE]: clearPageState
};
